import React, { useCallback, useState } from 'react'
import { AddNewCreditCardFlow_IDLE } from '../components/AddNewCreditCardFlow_IDLE'
import { AddNewCreditCardFlow_SUCCESS } from '../components/AddNewCreditCardFlow_CUSSESS'

enum STEPS {
  LINK_CARD,
  SUCCESS,
}

interface AddNewCreditCardFlowProps {
  onClose: () => void
  onSuccess: (data?: any) => void
  customRoute?: (data: any) => Promise<any>
  invoiceId: string
  phoneNumber?: string
  isGuest?: boolean
}

export const AddNewCreditCardFlow = ({
  onClose,
  onSuccess,
  customRoute,
  invoiceId,
  phoneNumber,
  isGuest,
}: AddNewCreditCardFlowProps) => {
  const [step, setStep] = useState(STEPS.LINK_CARD)
  const [response, setResponse] = useState<any>(null)

  const handleNext = () => {
    if (step === STEPS.LINK_CARD) {
      setStep(STEPS.SUCCESS)
    }
  }

  const handleSuccess = useCallback(() => {
    onSuccess(response)
  }, [response, onSuccess])

  return (
    <>
      {step === STEPS.LINK_CARD && (
        <AddNewCreditCardFlow_IDLE
          onClose={onClose}
          onSuccess={handleNext}
          customRoute={customRoute}
          setResponse={setResponse}
          invoiceId={invoiceId}
          phoneNumber={phoneNumber}
        />
      )}
      {step === STEPS.SUCCESS && (
        <AddNewCreditCardFlow_SUCCESS
          onSuccess={handleSuccess}
          isGuest={isGuest}
        />
      )}
    </>
  )
}
